import React from 'react';
import { Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { convertDateToLocal } from '../../util/date';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // example
import ErrorIcon from '@mui/icons-material/Error';
import Tooltip from '@mui/material/Tooltip';


const useStyles = makeStyles(theme => {
    return {
        date: {
            fontSize: '11px',
        },
        text: {
            lineHeight: "1.3"
        },
        hr: {
            margin: "5px"
        },
        comments: {
            maxHeight: 120,
            overflowY: 'scroll',

        }
    }
});

const renderStatusIcon = (comment) => {
    
    return comment.isFhirSync == null
    ? null
    : comment.isFhirSync
        ? <CheckCircleIcon color="success" fontSize="small" />
        : <ErrorIcon color="error" fontSize="small" />;

    };

function UserComments({ comments = [] }) {
    const classes = useStyles();

    return (
        <div className={classes.comments}>
            {comments.map(comment =>
                <>
                    <Grid key={comment.createdAt} container alignItems='center'>
                        <Grid item lg={3} md={4}>
                            <Typography>
                                <b>{comment.createdBy}</b>&nbsp;&nbsp; <span className={classes.date}>{convertDateToLocal(comment.createdAt)}</span>
                            </Typography>
                        </Grid>
                        <Grid item lg={7} md={6}>
                            <Typography className={classes.text}>
                                {comment.comment}
                            </Typography>
                        </Grid>
                        <Grid item xs />

                        {/* Status icon */}
                        <Grid item paddingRight={2}>
                            <Tooltip title={"Sync " + (comment.isFhirSync ? "Sucessful" : "Fail")}>
                                {renderStatusIcon(comment)}
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <hr className={classes.hr} />
                </>
            )}
        </div >
    )
}



export default UserComments;
